export default {
  title: 'Protocol',
  subtitle: 'Protocol Information',
  assign: 'Assign to a service',
  creationDate: 'Created on'
}
